import dayjs from 'dayjs';

import { useAppSelector } from '../../../lib/store';
import { useGetMetricsEncounterStatsQuery } from '../api/metricsApiSlice';
import {
  selectSelectedProjectId,
  selectEncounterStatsBatchTypeId,
  selectEncounterStatsStartDate,
  selectEncounterStatsEndDate,
} from '../state/selector';

export const useEncounterStatisticsDatagridFetch = (
  _searchParams?: string
): ReturnType<typeof useGetMetricsEncounterStatsQuery> => {
  const selectedProjectId = useAppSelector(selectSelectedProjectId);
  const batchTypeId = useAppSelector(selectEncounterStatsBatchTypeId);
  const startDate = useAppSelector(selectEncounterStatsStartDate);
  const endDate = useAppSelector(selectEncounterStatsEndDate);

  return useGetMetricsEncounterStatsQuery(
    {
      batchTypeId: batchTypeId || '',
      projectId: selectedProjectId || '',
      startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : undefined,
      endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : undefined,
    },
    { skip: !(selectedProjectId && batchTypeId) }
  );
};
